export const ESupSupplierType = {
  "0": "UNKNOWN",
  "1": "PRICER",
  "2": "TRANSPORTER",
  "3": "BOTH",
  "-1": "ALL"
};